/// <reference types="@angular/localize" />

import { EnvironmentProviders, Provider } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

async function buildSentryProviders(): Promise<Provider[]> {
  if (!environment.sentry?.enabled || !environment.sentry.dsn) {
    return [];
  }

  const { createSentryProviders } = await import('./app/sentry/sentry.providers');
  return createSentryProviders(environment.sentry.dsn);
}

async function buildServiceWorkerProviders(): Promise<EnvironmentProviders[]> {
  if (!environment.serviceWorker) {
    return [];
  }

  const { provideServiceWorker } = await import('@angular/service-worker');
  return [
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ];
}

// Silence verbose console logs in the app
// Keep warnings and errors to aid debugging
// If you prefer to scope this only to production, import environment and guard it.
const noop = () => {};
// @ts-ignore - allow reassignment for log level methods
console.log = noop;
// @ts-ignore
console.info = noop;
// @ts-ignore
console.debug = noop;

async function bootstrapApp(): Promise<void> {
  const [sentryProviders, serviceWorkerProviders] = await Promise.all([
    buildSentryProviders(),
    buildServiceWorkerProviders()
  ]);

  await bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [...appConfig.providers, ...sentryProviders, ...serviceWorkerProviders]
  });
}

bootstrapApp().catch(err => console.error(err));

